<template>
  <div>
    <div class="app-title">
      <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" ref="emListFilter"
                           :$_em-custom-vuex-mixin_vo="customVuexName + 'Vo'"
                           :$_em-custom-vuex-mixin_filter="customVuexName + 'Filter'"
                           :query-api="'findByFilter/' + customVuexName"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="mintalMesPrdProductionResultResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName"
                        ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                        :$_em-custom-vuex-mixin_vo="customVuexName + 'Vo'"
                        :$_em-custom-vuex-mixin_filter="customVuexName + 'Filter'"
                        :$_em-custom-vuex-mixin_entity="customVuexName + 'Entity'"
                        :query-api="'findByFilter/' + customVuexName"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                <template slot="left-header">
                  <b-button-group>
                    <em-button
                        type="gotoChild"
                        custom-icon="fa fa-th-list"
                        class="btn btn-outline-primary btn-sm"
                        :disabled="actionDisabled('selectOne')"
                        show-name custom-label="产品信息"
                        @click="gotoDetails('mintalMesPrdProductionInfo')">
                    </em-button>
                    <em-button
                        type="gotoChild"
                        custom-icon="fa fa-bars"
                        class="btn btn-outline-primary btn-sm"
                        :disabled="actionDisabled('selectOne')"
                        show-name custom-label="物料消耗"
                        @click="gotoDetails('mintalMesPrdProductionMaterialCost')">
                    </em-button>
                    <em-button
                        type="gotoChild"
                        custom-icon="fa fa-bars"
                        class="btn btn-outline-primary btn-sm"
                        :disabled="actionDisabled('selectOne')"
                        show-name custom-label="能源消耗"
                        @click="gotoDetails('mintalMesPrdProductionEnergyCost')">
                    </em-button>
                    <em-button
                        type="process"
                        class="btn btn-outline-primary btn-sm"
                        :disabled="actionDisabled('selectOne')"
                        show-name custom-label="质检单"
                        @click="gotoInspects">
                    </em-button>
                    <em-button
                        type="gotoChild"
                        custom-icon="fa fa-th-list"
                        class="btn btn-outline-primary btn-sm"
                        :disabled="actionDisabled('selectOne')"
                        show-name custom-label="设备利用指标"
                        @click="gotoDetails('mintalMesPrdProductionEquipQuota')">
                    </em-button>
                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
  </div>
</template>
<script>
// Author liang gang qiang
// Date 2021-10-13 14:13:23

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import customVuexNameMixin from "@/mixin/em/common/stuffs/customVuex/customVuexNameMixin";

export default {
  name: "mintalMesPrdProductionResultListView",
  mixins: [emCommonListMixin, emCommonGotoMixin, emTableCheckedMixin, customVuexNameMixin],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    },
    customVuexName: {
      type: String
    }
  },
  computed: {
    modelName() {
      return 'mintalMesPrdProductionResult'
    },
    isPelletizing() {
      return this.customVuexName === 'pelletizing';
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
      this.$refs.emListFilter.doQuery();
    } else if (this.$route.query.shiftPlanId) {
      this.insertHolder('prdShiftPlanId', this.$route.query.shiftPlanId);
    }
  },
  methods: {
    gotoDetails(entity) {
      this.$_emGotoMixin_gotoHolderList(entity
          , {prdResultIdFilter: this.selectIds}
          , {prdResultId: this.selectIds}, false, {
            customVuexName: this.customVuexName,
            prdResultId: this.selectIds
          });
    },
    gotoInspects() {
      let type = this.isPelletizing ? 3 : 4;
      this.$_emGotoMixin_gotoHolderList('mintalMesQualityProductionProject'
          , {inspectObjectFilter: this.selectIds, inspectTypeFilter: type}
          , {inspectObject: this.selectIds, inspectType: type}, false, {});
    }
  }
};
</script>